import { formatDuration, type Plan } from "@roxpacer/core";
import { RaceCardTable, planDescription } from "../components/RaceCardTable";
import { navigate } from "../lib/router";
import { useEstimate } from "../lib/use-estimate";

/** Printable, phone-friendly card with the targets to carry on race day. */
export function RaceCardPage({ plan, backTo }: { plan: Plan; backTo: string }) {
  const estimate = useEstimate(plan);

  return (
    <main className="mx-auto max-w-2xl px-4 py-4 print:max-w-none print:p-0">
      <div className="mb-4 flex gap-2 print:hidden">
        <button type="button" className="btn" onClick={() => navigate(backTo)}>
          ← Back
        </button>
        <button type="button" className="btn btn-primary ml-auto" onClick={() => window.print()}>
          Print
        </button>
      </div>

      <article className="card p-4 sm:p-6 print:border-0 print:p-0">
        <header className="flex flex-wrap items-end justify-between gap-x-6 gap-y-2">
          <div className="min-w-0">
            <h1 className="text-2xl font-semibold tracking-tight break-words">{plan.name}</h1>
            <p className="mt-0.5 text-sm text-ink-2">{planDescription(plan)}</p>
          </div>
          <div className="sm:text-right">
            <p className="label">Target finish</p>
            <p className="text-4xl font-semibold tabular-nums">
              {formatDuration(estimate.totalSec, { alwaysHours: true })}
            </p>
          </div>
        </header>
        <div className="mt-4">
          <RaceCardTable plan={plan} large />
        </div>
        <p className="mt-4 text-xs text-muted">
          Run: pace per km. Rox in / Rox out: Roxzone allowance before and after the station. Done
          by: race clock at the end of the station. Planned with roxpacer.com
        </p>
      </article>
    </main>
  );
}
